'use client';

import { ChevronRight, Send } from 'lucide-react';
import { ModalShell } from '@/components/ui/ModalShell';
import { SOLICITUD_TIPOS, type TipoSolicitudCreable } from './solicitudTipos';

interface TipoSolicitudSelectorModalProps {
	onClose: () => void;
	onSelect: (tipo: TipoSolicitudCreable) => void;
}

/**
 * Small modal that asks WHICH request to create. It is always shown, even with a single registered type
 * (UAR-05). It is a form-like modal with no state to discard: "Cancelar" just closes it, there is no undo.
 */
export function TipoSolicitudSelectorModal({ onClose, onSelect }: TipoSolicitudSelectorModalProps) {
	return (
		<ModalShell
			title="Nueva solicitud"
			icon={<Send size={16} />}
			onClose={onClose}
			onCancel={onClose}
			cancelText="Cancelar"
			showSaveAction={false}
			hideFooterIndicator
			maxWidth="28rem"
		>
			<p className="mb-3 text-sm text-slate-600">¿Qué tipo de solicitud quieres enviar?</p>
			<ul className="flex flex-col gap-2">
				{SOLICITUD_TIPOS.map(({ tipo, label, descripcion, Icon }) => (
					<li key={tipo}>
						<button
							type="button"
							onClick={() => onSelect(tipo)}
							className="flex w-full cursor-pointer items-center gap-3 rounded-[10px] border border-slate-200 bg-white px-3.5 py-3 text-left transition hover:border-[#233a4d] hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#233a4d]"
						>
							<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[#233a4d]">
								<Icon size={18} aria-hidden="true" />
							</span>
							<span className="min-w-0 flex-1">
								<span className="block text-sm font-semibold text-slate-800">{label}</span>
								<span className="block text-xs leading-snug text-slate-500">{descripcion}</span>
							</span>
							<ChevronRight size={16} className="shrink-0 text-slate-400" aria-hidden="true" />
						</button>
					</li>
				))}
			</ul>
		</ModalShell>
	);
}
